import { ExperienceRole } from '../types/content';

export const experiences: ExperienceRole[] = [
  {
    title: 'Product Development Manager',
    org: 'Ameren Missouri',
    period: '01/2026 to Present',
    highlights: [
      'Leading rate-regulated, customer-facing renewable strategies.',
      'Managing 400+ MW of solar subscriptions across 4 installations.',
      'Leading Phase 4 rollouts and coordinating Clean Capacity Advancement programs.'
    ]
  },
  {
    title: 'Manager, Business Services',
    org: 'Ameren Missouri',
    period: '09/2024 to 12/2025',
    highlights: [
      'Directed commercial growth strategies for the utility.',
      'Advised C-suite capital allocation decisions.',
      'Established net new revenue KPIs and deployed the electric customer energy analysis portal.'
    ]
  },
  {
    title: 'Manager, Innovation & Electrification',
    org: 'Ameren',
    period: '08/2019 to 09/2024',
    highlights: [
      'Managed 10+ annual project portfolios and served on the EPRI Technology & Innovation Committee.',
      'Chaired EPRI Program 199 and managed 14 Incubatenergy Labs pilots.',
      'Led the Energy Impact Partners (EIP) venture collaboration.'
    ]
  },
  {
    title: 'Senior Innovation Analyst & Business Analyst',
    org: 'Ameren',
    period: '03/2017 to 07/2019',
    highlights: [
      'Built financial ROI models for long-term grid investments.',
      'Acted as Agile Scrum Master and Product Owner.',
      'Built the crowd-sourced ideation platform (Spigit) with 350+ ideas and created the Monthly Innovation Event series.'
    ]
  },
  {
    title: 'Co-Founder & Managing Director',
    org: 'Global Innovation Project & Krooze',
    period: '2015 to 2017',
    highlights: [
      'Led Latin American incubator partnerships in Rio de Janeiro and Quito.',
      'Developed event-based rideshare platforms.'
    ]
  }
];
